import type React from 'react';

import MuiFormLabel, { type FormLabelProps } from '@mui/material/FormLabel';

import { useStyles as useTypographyStyles } from 'components/typography/styles';

import { useStyles } from './styles';

const FormLabel: React.FC<React.PropsWithChildren<FormLabelProps>> = ({ children, ...props }) => {
  const { classes: typographyClasses } = useTypographyStyles();
  const { classes } = useStyles();

  return (
    <MuiFormLabel className={`${typographyClasses.formLabelText} ${classes.formLabel}`} {...props}>
      {children}
    </MuiFormLabel>
  );
};

export default FormLabel;
